<template>
	<div>
		<!-- 编辑界面 -->
		<el-dialog :visible.sync="editFormVisible" :title="title" width="800px" :close-on-click-modal="false" @click="closeDialog">
			<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules" class="demo-form-inline" inline>
				<el-form-item label="模块编号" prop="moduleCode">
					<el-input clearable v-model="editForm.moduleCode" size="small" auto-complete="off" placeholder="请输入模块编号" class="input_200px"></el-input>
				</el-form-item>
				<el-form-item label="模块名称" prop="moduleName">
					<el-input clearable v-model="editForm.moduleName" size="small" auto-complete="off" placeholder="请输入模块名称" class="input_200px"></el-input>
				</el-form-item>
				<el-form-item label="模块类型" prop="moduleType">
					<el-select v-model="editForm.moduleType" size="small" filterable placeholder="请选择" class="input_200px">
						<el-option v-for="item in moduleTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模块子类型" prop="moduleSubType">
					<el-select v-model="editForm.moduleSubType" size="small" filterable placeholder="请选择" value-key="value" class="input_200px">
						<el-option v-for="item in moduleSubTypeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模块地址" prop="moduleUrl">
					<el-input clearable v-model="editForm.moduleUrl" size="small" auto-complete="off" placeholder="请输入url链接" :disabled="isEdit" style="width: 550px"></el-input>
				</el-form-item>
				<el-form-item label="描述" prop="desc">
					<el-input v-model="editForm.desc" type="textarea" size="small " autosize auto-complete="off" placeholder="请输入描述" :rows="4" style="width: 550px"></el-input>
				</el-form-item>
				<el-form-item label="父级模块" prop="parentId">
					<el-input clearable v-model="selectedMenu.namex" size="small" auto-complete="off" placeholder="父级模块" style="width: 550px" @focus="menuAccess"></el-input>
				</el-form-item>
				<el-form-item label="图标" prop="icon">
					<el-popover placement="bottom" width="450" trigger="click">
						<template #reference>
							<span style="display: inline-block; width: 198px; height: 40px; line-height: 40px">
								<i :class="userChooseIcon" style="font-size: 40px"></i>
								{{ chooseIcons }}
							</span>
						</template>
						/*图标选择页面*/
						<div class="iconList">
							<i v-for="item in iconList" :key="item" :class="item" style="font-size: 30px" @click="setIcon(item)"></i>
						</div>
					</el-popover>
				</el-form-item>
				<el-form-item label="颜色" prop="color">
					<el-color-picker v-model="editForm.color"></el-color-picker>
				</el-form-item>
				<el-form-item label="显示顺序" prop="seq">
					<el-input v-model.number="editForm.seq" size="small" auto-complete="off" placeholder="请输入显示顺序" style="width: 200px"></el-input>
				</el-form-item>
			</el-form>
			<template #footer>
				<div class="dialog-footer">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
				</div>
			</template>
		</el-dialog>
		<!-- 上级菜单 -->
		<el-dialog :visible.sync="menuAccessshow" title="上级菜单" width="576px" :close-on-click-modal="false" @click="closeDialog('perm')">
			<el-input clearable v-model="filterText" size="mini" placeholder="请输入关键字进行过滤"></el-input>
			<el-tree
				ref="tree"
				style="margin-top: 10px"
				class="filter-tree"
				:default-expand-all="false"
				:data="RoleRight"
				:props="RoleRightProps"
				:default-expanded-keys="treeExpandData"
				:default-checked-keys="checkedKeyArray"
				node-key="keyId"
				show-checkbox
				highlight-current
				check-strictly
				:expand-on-click-node="false"
				:filter-node-method="filterNode"
				@check-change="handleClick"
				@check="checkMenu"
			></el-tree>
			<template #footer>
				<div class="dialog-footer">
					<el-button size="small" @click="closeDialog2('perm')">取消</el-button>
					<el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">确定</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script>
import { GetModuleInfoByKeyId, SaveModule, GetModuleTreeList } from "../../../api/systemApi.js";
import { elementIcons } from "../../../utils/icon.js";
export default {
	props: ["moduleTypeList", "moduleSubTypeList"],
	data() {
		return {
			treeExpandData: [],
			checkedKeyArray: [],
			iconList: [],
			userChooseIcon: "",
			chooseIcons: "",
			selectedMenu: {
				namex: ""
			},
			menuAccessshow: false,
			loading: false, //是显示加载
			RoleRight: [],
			RoleRightProps: {
				children: "subModules",
				label: "moduleName"
			},
			title: "",
			filterText: "",
			editFormVisible: false, //控制编辑页面显示与隐藏
			isEdit: true,
			editForm: {
				keyId: "",
				moduleCode: "",
				moduleName: "",
				moduleUrl: "",
				moduleType: "1",
				moduleSubType: "1",
				desc: "",
				parentId: "",
				seq: "",
				isShow: true,
				icon: "",
				color: ""
			},
			// rules表单验证
			rules: {
				moduleCode: [
					{
						required: true,
						message: "请输入模块编号",
						trigger: "blur"
					}
				],
				moduleName: [
					{
						required: true,
						message: "请输入模块名称",
						trigger: "blur"
					}
				],
				moduleType: [
					{
						required: true,
						message: "请选择模块类型",
						trigger: "change"
					}
				],
				moduleSubType: [
					{
						required: true,
						message: "请选择模块子类型",
						trigger: "change"
					}
				],
				seq: [
					{
						required: true,
						message: "请输入显示顺序",
						trigger: "blur"
					},
					{
						type: "number",
						message: "请输入数字格式",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		}
	},
	methods: {
		setIcon(icon) {
			this.editForm.icon = icon;
			this.userChooseIcon = icon; //将i的样式设为选中的样式el-icon-xxx
			this.chooseIcons = "";
		},
		handleClick(data, checked, node) {
			if (checked) {
				this.currentNodeData = data;
				this.$refs.tree.setCheckedNodes([data]);
			}
		},
		// 上级菜单数据
		menuAccess() {
			this.menuAccessshow = true;
			let parmter = {
				moduleName: ""
			};
			GetModuleTreeList(parmter)
				.then((res) => {
					if (res.code == 1) {
						// this.RoleRight = this.changeArr(res.data);
						this.RoleRight = res.data;
					} else {
						this.$message({
							type: "info",
							message: res.data.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取权限失败，请稍后再试！");
				});
		},
		// 选择菜单节点时候的钩子
		checkMenu(obj, list) {
			if (list.checkedKeys.length === 0) {
				this.selectedMenu.id = "";
				this.selectedMenu.name = "";
				this.selectedMenu.name2 = "";
				this.selectedMenu.name3 = "";
				this.editForm.parentId = "";
				this.checkedKeyArray = [];
				this.treeExpandData = [];
			} else {
				if (obj.parentId) {
					this.RoleRight.map((v) => {
						if (obj.parentId == v.keyId) {
							this.selectedMenu.name = v.moduleName;
							return;
						} else {
						}
						if (v.subModule !== "") {
							v.subModule.forEach((item) => {
								if (item.keyId == obj.parentId) {
									this.selectedMenu.name = v.moduleName;
									this.selectedMenu.name3 = item.moduleName;
									return;
								} else {
								}
							});
						}
					});
				} else {
					this.selectedMenu.name = "";
					this.selectedMenu.name3 = "";
				}
				this.selectedMenu.id = list.checkedNodes[0].keyId;
				this.selectedMenu.name2 = list.checkedNodes[0].moduleName;
			}
		},
		// 上级菜单保存
		menuPermSave() {
			this.editForm.parentId = this.selectedMenu.id;
			if (this.selectedMenu.name && this.selectedMenu.name3) {
				this.selectedMenu.namex = this.selectedMenu.name + "/" + this.selectedMenu.name3 + "/" + this.selectedMenu.name2;
			} else if (this.selectedMenu.name3 == "" && this.selectedMenu.name) {
				this.selectedMenu.namex = this.selectedMenu.name + "/" + this.selectedMenu.name2;
			} else {
				this.selectedMenu.namex = this.selectedMenu.name2;
			}
			this.checkedKeyArray = [];
			this.treeExpandData = [];
			this.checkedKeyArray.push(this.editForm.parentId);
			this.treeExpandData.push(this.editForm.parentId);
			this.menuAccessshow = false;
		},
		closeDialog2() {
			this.menuAccessshow = false;
			// this.$refs['editForm'].resetFields()
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$refs["editForm"].resetFields();
			this.selectedMenu.name2 = "";
			this.selectedMenu.name3 = "";
		},
		//显示编辑界面
		editShow(row) {
			this.userChooseIcon = "";
			if (row != undefined && row != "undefined") {
				this.title = "编辑";
				this.isEdit = true;
				let parmar = {
					keyId: row.keyId
				};
				GetModuleInfoByKeyId(parmar)
					.then((res) => {
						if (res.data) {
							if (res.data.moduleUrl == null) {
								this.editForm.moduleUrl = "";
							} else if (res.data.moduleUrl) {
								this.editForm.moduleUrl = res.data.moduleUrl;
							}
							this.editForm = res.data;
							this.editForm.moduleSubType = res.data.moduleSubType + "";
							this.editForm.moduleType = res.data.moduleType + "";
							this.userChooseIcon = res.data.icon;
							this.checkedKeyArray = [];
							this.treeExpandData = [];
							this.checkedKeyArray.push(res.data.parentId);
							this.treeExpandData.push(res.data.parentId);
							this.selectedMenu.namex = res.data.moduleName;
							if (res.data.parentId) {
								this.$parent.listData.map((v) => {
									if (v.subModules !== "") {
										v.subModules.forEach((item) => {
											if (item.keyId == res.data.parentId) {
												this.selectedMenu.namex = item.moduleName + "/" + this.selectedMenu.namex;
												this.selectedMenu.namex = v.moduleName + "/" + this.selectedMenu.namex;
												return;
											} else {
											}
										});
									}
									if (res.data.parentId == v.keyId) {
										this.selectedMenu.namex = v.moduleName + "/" + this.selectedMenu.namex;
										return;
									} else {
									}
								});
							}
						}
					})
					.catch((err) => {
						console.log(err);
						this.$message.error("加载失败，请稍后再试！");
					});
			} else {
				this.title = "新增";
				this.isEdit = false;
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.selectedMenu = {
					id: "",
					name: "",
					name2: "",
					name3: ""
				};
				this.checkedKeyArray = [];
				this.treeExpandData = [];
			}
			this.editFormVisible = true;
		},

		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					this.editForm.moduleSubType = Number(this.editForm.moduleSubType);
					this.editForm.moduleType = Number(this.editForm.moduleType);
					SaveModule(this.editForm)
						.then((res) => {
							this.loading = false;
							if (res.code === 1) {
								this.editFormVisible = false;
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "保存成功！"
								});
							} else {
								this.editForm.moduleSubType = this.editForm.moduleSubType + "";
								this.editForm.moduleType = this.editForm.moduleType + "";
								this.$message({
									type: "error",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error("保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 新增子级菜单
		addModule(row) {
			this.userChooseIcon = "";
			this.title = "新增子级菜单";
			this.isEdit = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
			this.editForm.parentId = row.keyId;
			this.selectedMenu = {
				id: "",
				name: "",
				name2: "",
				name3: ""
			};
			this.selectedMenu.namex = row.moduleName;
			this.checkedKeyArray = [];
			this.treeExpandData = [];
			this.editFormVisible = true;
		},
		filterNode(value, data) {
			if (!value) return true;
			return data.name.indexOf(value) !== -1;
		}
	},
	created() {
		this.iconList = elementIcons;
	},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.iconList {
	width: 400px;
	height: 300px;
	overflow-y: scroll;
	overflow-x: hidden;
	display: flex;
	justify-content: space-around;
	flex-wrap: wrap;
}

.iconList i {
	display: inline-block;
	width: 60px;
	height: 45px;
	color: #000000;
	font-size: 20px;
	border: 1px solid #e6e6e6;
	border-radius: 4px;
	cursor: pointer;
	text-align: center;
	line-height: 45px;
	margin: 5px;
}

.iconList i:hover {
	color: aquamarine;
}

.el-popover__reference {
	border: 1px dashed #5b5b5b;
	text-align: center;
}
</style>
